import firebase from "firebase/app";
import Vue from 'vue'

export const statsMixin = {
  data() {
    return {
      newUsersChartKeyToRerender: 0,
      assessmentsChartKeyToRerender: 0,
      videosChartKeyToRerender: 0,
      coursesChartKeyToRerender: 0,
      returningUsersChartKeyToRerender: 0,

      newThisMonth: {
        number: 0,
        inprevmonth: 0,
        updown: 'up',
      },

      totalUsers: {
        number: 0
      },
      totalAssessments: {
        started: 0,
        finished: 0,
        averagescore: 0.0
      },
      totalVideos: {
        started: 0,
        finished: 0,
      },
      totalCourses: {
        started: 0,
        finished: 0,
      },


      barChartDataNewUsers: {
        labels: [
          "Jan",
          "Feb",
          "Mar",
          "Apr",
          "May",
          "Jun",
          "Jul",
          "Aug",
          "Sep",
          "Oct",
          "Nov",
          "Dec"
        ],
        datasets: [
          {
            label: "",
            data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
            backgroundColor: "rgba(255, 200, 44, 0.9)",
            borderWidth: 0
          }
        ]
      },


      lineChartDataAssessments: {
        labels: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Now", "Dec"],
        datasets: [
          {
            label: "",
            backgroundColor: "rgba(85, 66, 251, 1)",
            data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
          }
        ]
      },

      lineChartDataVideos: {
        labels: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Now", "Dec"],
        datasets: [
          {
            label: "",
            backgroundColor: "rgba(85, 66, 251, 1)",
            data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
          }
        ]
      },

      lineChartDataCourses: {
        labels: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Now", "Dec"],
        datasets: [
          {
            label: "",
            backgroundColor: "rgba(85, 66, 251, 1)",
            data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
          }
        ]
      },

      lineChartDataReturningUsers: {
        labels: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Now", "Dec"],
        datasets: [
          {
            label: "",
            backgroundColor: "rgba(85, 66, 251, 1)",
            data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
          }
        ]
      },


    }
  },
  computed: {
    barChartDataNewUsersComputed() {
      return this.barChartDataNewUsers
    },
    newThisMonthPercent() {
      if (this.newThisMonth.inprevmonth == 0 && this.newThisMonth.number > 0) return 100;
      if (this.newThisMonth.inprevmonth == 0 && this.newThisMonth.number == 0) return 0;

      return Math.floor((this.newThisMonth.number - this.newThisMonth.inprevmonth) * 100 / this.newThisMonth.inprevmonth)
    },
    newThisMonthIcon() {

      if (this.newThisMonthPercent > 0) return 'long-arrow-alt-up'
      if (this.newThisMonthPercent < 0) return 'long-arrow-alt-down'
      return ''

      // if (this.newThisMonth.inprevmonth == 0 && this.newThisMonth.number > 0) return 100;
      // if (this.newThisMonth.inprevmonth == 0 && this.newThisMonth.number == 0) return 0;

      // return Math.floor((this.newThisMonth.number - this.newThisMonth.inprevmonth) * 100 / this.newThisMonth.inprevmonth)


    },
  },
  methods: {

    mthMixinSetNewThisMonth() {
      let dt = new Date();
      let ystr = dt.getFullYear().toString();
      let mstr = (dt.getMonth() + 1).toString();


    },
    mthMixinFillNewUsersStatsDataSource() {
      //barChartDataNewUsers
      let dt = new Date();
      let ystr = dt.getFullYear().toString();
      let mstr = (dt.getMonth() + 1).toString();
      //this.barChartDataNewUsers.datasets[0].data = [];
      for (let i = 1; i < 13; i++) {
        //this.barChartDataNewUsers.datasets[0].data[i - 1] =
        this.mthMixinFillNewUsersByYearMonth(ystr, i.toString(), i - 1)
      }

    },
    mthMixinFillAssessmentsDataSource() {
      //barChartDataNewUsers
      let dt = new Date();
      let ystr = dt.getFullYear().toString();
      let mstr = (dt.getMonth() + 1).toString();
      this.lineChartDataAssessments.datasets[0].data = [];
      for (let i = 1; i < 13; i++) {
        //this.lineChartDataAssessments.datasets[0].data[i - 1] = i-1
        Vue.set(this.lineChartDataAssessments.datasets[0].data, i - 1, i - 1);

        this.mthMixinFillStartedAssessmentsByYearMonth(ystr, i.toString(), i - 1)
        this.mthMixinFillFinishedAssessmentsByYearMonth(ystr, i.toString(), i - 1)
      }
    },
    mthMixinFillVideosAndCoursesDataSource() {
      console.log('mthMixinFillVideosAndCoursesDataSource')

      //barChartDataNewUsers
      let dt = new Date();
      let ystr = dt.getFullYear().toString();
      let mstr = (dt.getMonth() + 1).toString();
      this.lineChartDataVideos.datasets[0].data = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
      this.videosChartKeyToRerender++


      firebase
        .firestore()
        .collection("progressTracking")
        .get()
        .then(
          result => {

            let month = 0

            result.forEach(
              doc => {
                if (doc.data().dateandtime !== undefined) {
                  //console.log(doc.data().dateandtime.seconds)

                  var date = new Date(doc.data().dateandtime.seconds * 1000);
                  var month = date.getMonth();




                } else {
                  //console.log('no timestamp!')
                  month = 7

                }

                this.totalVideos.started++
                if (doc.data().vimeoidended) this.totalVideos.finished++


                console.log('month is: ' + month)

                this.lineChartDataVideos.datasets[0].data[month]++
                if (doc.data().videolistindexforstats !== undefined && doc.data().videolistindexforstats == 0) {
                  this.lineChartDataCourses.datasets[0].data[month]++
                  this.totalCourses.started++
                }

                if (
                  doc.data().videolistindexforstats !== undefined
                  && doc.data().videolistindexforstats == doc.data().howmuchvideosisinthiscourse
                  && doc.data().vimeoidended !== undefined
                ) {
                  this.totalCourses.finished++
                }

              }
            )

            this.videosChartKeyToRerender++
            //if (doc.data().videolistindexforstats && doc.data().videolistindexforstats == 0) {
            this.coursesChartKeyToRerender++
            //}
          }
        )



      for (let i = 1; i < 13; i++) {
        //this.lineChartDataAssessments.datasets[0].data[i - 1] = i-1
        //Vue.set(this.lineChartDataVideos.datasets[0].data, i - 1, i - 1);

        //this.mthMixinFillStartedAssessmentsByYearMonth(ystr, i.toString(), i - 1)
        //this.mthMixinFillFinishedAssessmentsByYearMonth(ystr, i.toString(), i - 1)
      }
    },
    mthMixinFillReturningUsersDataSource() {
      //barChartDataNewUsers
      let dt = new Date();
      let ystr = dt.getFullYear().toString();
      let mstr = (dt.getMonth() + 1).toString();
      this.lineChartDataReturningUsers.datasets[0].data = [];
      for (let i = 1; i < 13; i++) {
        //this.lineChartDataAssessments.datasets[0].data[i - 1] = i-1
        //Vue.set(this.lineChartDataReturningUsers.datasets[0].data, i - 1, i - 1);

        this.mthMixinFillReturningUsersByYearMonth(ystr, i.toString(), i - 1)
        // this.mthMixinFillFinishedAssessmentsByYearMonth(ystr, i.toString(), i - 1)
      }
    },


    mthMixinFillStartedAssessmentsByYearMonth(ystr, mstr, index) {
      let dt = new Date();
      let ystrcurr = dt.getFullYear().toString();
      let ystrprev = dt.getFullYear().toString();
      let mstrcurr = (dt.getMonth() + 1).toString();
      let mstrprev = (dt.getMonth()).toString();
      if (mstrprev == '0') { mstrprev == '12'; ystrprev = (dt.getFullYear() - 1).toString() }


      let that = this
      const docref = firebase
        .firestore()
        .collection('statsAssessments')
        .doc(ystr + '-' + mstr)

      //exists?
      const dd = docref.get().then(
        (snap) => {
          if (!snap.exists) {
            //console.log('not exists, before set');
            //console.log(that.lineChartDataAssessments.datasets[0].data);

            //that.ret.push(0);
            //that.ret = 0
            //that.barChartDataNewUsers.datasets[0].data[index] = 1
            //that.barChartDataNewUsers.datasets[0].data.push(index)
            Vue.set(that.lineChartDataAssessments.datasets[0].data, index, 0);
            this.assessmentsChartKeyToRerender += 1



          }
          else {
            console.log('exists' + snap.data().counter);
            //that.ret.push(snap.data().counter)
            //that.ret = snap.data().counter
            //that.barChartDataNewUsers.datasets[0].data[index] = snap.data().counter
            // that.barChartDataNewUsers.datasets[0].data.push(snap.data().counter)
            Vue.set(that.lineChartDataAssessments.datasets[0].data, index, snap.data().counter);
            this.assessmentsChartKeyToRerender += 1

            that.totalAssessments.started += snap.data().counter
            // if (ystr == ystrcurr && mstr == mstrcurr) {
            //   that.newThisMonth.number = snap.data().counter
            // }
            // if (ystr == ystrprev && mstr == mstrprev) {
            //   that.newThisMonth.inprevmonth = snap.data().counter
            // }
            // that.totalUsers.number += snap.data().counter

          }
        }
      )
      //console.log(that.ret);


      //return that.ret;
    },


    mthMixinFillReturningUsersByYearMonth(ystr, mstr, index) {
      let dt = new Date();
      let ystrcurr = dt.getFullYear().toString();
      let ystrprev = dt.getFullYear().toString();
      let mstrcurr = (dt.getMonth() + 1).toString();
      let mstrprev = (dt.getMonth()).toString();
      if (mstrprev == '0') { mstrprev == '12'; ystrprev = (dt.getFullYear() - 1).toString() }


      let that = this
      const docref = firebase
        .firestore()
        .collection('statsReturningUsers')
        .doc(ystr + '-' + mstr)

      //exists?
      const dd = docref.get().then(
        (snap) => {
          if (!snap.exists) {
            Vue.set(that.lineChartDataReturningUsers.datasets[0].data, index, 0);
            this.returningUsersChartKeyToRerender += 1
          }
          else {
            console.log('exists' + snap.data().counter);
            Vue.set(that.lineChartDataReturningUsers.datasets[0].data, index, snap.data().counter);
            this.returningUsersChartKeyToRerender += 1
            //that.totalAssessments.started += snap.data().counter
          }
        }
      )
    },

    mthMixinFillFinishedAssessmentsByYearMonth(ystr, mstr, index) {
      let dt = new Date();
      let ystrcurr = dt.getFullYear().toString();
      let ystrprev = dt.getFullYear().toString();
      let mstrcurr = (dt.getMonth() + 1).toString();
      let mstrprev = (dt.getMonth()).toString();
      if (mstrprev == '0') { mstrprev == '12'; ystrprev = (dt.getFullYear() - 1).toString() }


      let that = this
      const docref = firebase
        .firestore()
        .collection('statsAssessmentsFinished')
        .doc(ystr + '-' + mstr)

      //exists?
      const dd = docref.get().then(
        (snap) => {
          if (!snap.exists) {


          }
          else {

            that.totalAssessments.finished += snap.data().counter
            var scoresum = 0
            if (snap.data().scoresum !== undefined) scoresum = snap.data().scoresum

            var rounded = Number((scoresum / snap.data().counter).toFixed(1));
            that.totalAssessments.averagescore = rounded

          }
        }
      )
      //console.log(that.ret);


      //return that.ret;
    },
    mthMixinFillNewUsersByYearMonth(ystr, mstr, index) {

      let dt = new Date();
      let ystrcurr = dt.getFullYear().toString();
      let ystrprev = dt.getFullYear().toString();
      let mstrcurr = (dt.getMonth() + 1).toString();
      let mstrprev = (dt.getMonth()).toString();
      if (mstrprev == '0') { mstrprev == '12'; ystrprev = (dt.getFullYear() - 1).toString() }


      let that = this
      const docref = firebase
        .firestore()
        .collection('statsNewUsers')
        .doc(ystr + '-' + mstr)

      //exists?
      const dd = docref.get().then(
        (snap) => {
          if (!snap.exists) {
            //console.log('not exists, before set');
            //console.log(that.lineChartDataAssessments.datasets[0].data);

            //that.ret.push(0);
            //that.ret = 0
            //that.barChartDataNewUsers.datasets[0].data[index] = 1
            //that.barChartDataNewUsers.datasets[0].data.push(index)
            Vue.set(that.barChartDataNewUsers.datasets[0].data, index, 0);
            this.newUsersChartKeyToRerender += 1


          }
          else {
            console.log('exists' + snap.data().counter);
            //that.ret.push(snap.data().counter)
            //that.ret = snap.data().counter
            //that.barChartDataNewUsers.datasets[0].data[index] = snap.data().counter
            // that.barChartDataNewUsers.datasets[0].data.push(snap.data().counter)
            Vue.set(that.barChartDataNewUsers.datasets[0].data, index, snap.data().counter);
            this.newUsersChartKeyToRerender += 1
            if (ystr == ystrcurr && mstr == mstrcurr) {
              that.newThisMonth.number = snap.data().counter
            }
            if (ystr == ystrprev && mstr == mstrprev) {
              that.newThisMonth.inprevmonth = snap.data().counter
            }
            that.totalUsers.number += snap.data().counter

          }
        }
      )
      //console.log(that.ret);


      //return that.ret;

    },
    mthMixinStatsIncrementNewUsers() {
      let dt = new Date();
      let y = dt.getFullYear().toString()
      let m = (dt.getMonth() + 1).toString()

      console.log('callin');

      const docref = firebase
        .firestore()
        .collection('statsNewUsers')
        .doc(y + '-' + m)

      //exists?
      docref.get().then(
        (snap) => {
          if (!snap.exists) {
            const docref = firebase
              .firestore()
              .collection('statsNewUsers')
              .doc(y + '-' + m).set({ counter: 1 })
          }
          else {
            const increment = firebase.firestore.FieldValue.increment(1);
            docref.update({ counter: increment })

          }
        }
      )
    },

  },
}

